<!-- Sidebar -->
<p-drawer
  [visible]="viewAppointmentSidebar()"
  [showCloseIcon]="false"
  position="right"
  [blockScroll]="true"
  [dismissible]="false"
  styleClass="w-full md:w-30rem client-profile-sidebar p-0"
  (onHide)="CloseViewAppointmentSidebar()"
  appendTo="body"
  [autoZIndex]="true"
  data-testid="view-appointment-sidebar"
>
  <!-- Header -->
  <ng-template #header>
    <div class="border-bottom-1 border-300 sticky top-0 left-0 z-3 w-full">
      <!-- Header Top -->
      <div class="flex border-bottom-1 border-300 surface-0">
        <!-- Close Icon -->
        <div
          class="w-2rem px-4 cursor-pointer flex align-items-center justify-content-center"
          (click)="CloseViewAppointmentSidebar()"
          data-testid="close-sidebar-button"
        >
          <i class="fa fa-times text-base text-600"></i>
        </div>
        <!-- Close Icon -->

        <strong
          class="text-green-400 font-bold text-sm m-2 p-1"
          aria-label="appointment-type"
          >{{
            appointmentData()!.type_name_primary_language ||
              appointmentData()!.type_name_secondary_language
          }}</strong
        >
      </div>
      <!-- Header Top -->

      @if (
        appointmentData()!.status.toLowerCase() === AppointmentStatus.Cancelled.toLowerCase()
      ) {
        <p-message severity="error" aria-label="cancelled-message" styleClass="mb-2">
          <div class="p-warn flex align-items-center w-full -m-1">
            <i
              class="fa fa-exclamation-triangle p-warn text-xl"
              aria-label="warning-icon"
            ></i>
            <div class="ml-2 line-height-3 text-sm">
              <strong class="block">{{
                'SCHEDULE.VIEWAPPOINTMENT.APPT_CANCELLED' | translate
              }}</strong>
              @if (appointment) {
                <span class="block">{{
                  appointment!.cancellation_reason
                }}</span>
              }
            </div>
          </div>
        </p-message>
      }
      <!-- Header Bottom -->
      <div
        class="bg-green-50 md:flex align-items-start md:align-items-center justify-content-between py-2 md:py-3 relative px-2 xl:px-0"
      >
        <!-- Client Name -->
        @if (appointmentData()!) {
          <div class="md:w-6 px-2" aria-label="client-info">
            <div class="flex align-items-center">
              @if (appointmentData()!.clients[0].image) {
                <p-avatar
                  [image]="appointmentData()!.clients[0].image"
                  size="large"
                  aria-label="client-avatar"
                />
              } @else {
                <p-avatar
                  [label]="
                    appointmentData()!.clients[0].full_name
                      | titlecase
                      | shortName
                  "
                  size="large"
                  aria-label="client-avatar-placeholder"
                />
              }
              <div
                class="ml-2 w-full md:w-auto flex align-items-center justify-content-between md:block"
              >
                @if (
                  appointmentData()!.clients &&
                  appointmentData()!.clients.length > 0
                ) {
                  <div
                    class="mr-2 text-sm flex align-items-center white-space-nowrap"
                  >
                    <strong
                      class="cursor-pointer text-primary overflow-hidden white-space-nowrap text-overflow-ellipsis"
                      tooltipPosition="left"
                      [pTooltip]="appointmentData()!.clients[0].full_name"
                      tooltipStyleClass="text-xs"
                      aria-label="client-name"
                    >
                      {{ appointmentData()!.clients[0].full_name }}
                    </strong>
                    <span
                      class="text-xs text-600 ml-2 font-normal"
                      aria-label="client-id"
                    >
                      - {{ appointmentData()!.clients[0].id }}</span
                    >
                  </div>
                }

                <div class="flex align-items-center ml-2 md:ml-0">
                  <div
                    [innerHTML]="clientStatus(appointmentData()!.clients[0])"
                  ></div>
                  <div class="hidden md:flex align-items-center ml-2">
                    <span
                      class="w-1rem h-1rem border-circle flex align-items-center justify-content-center surface-400 mr-1"
                    >
                      <i
                        class="fa fa-star-fill text-primary text-xxs"
                        aria-label="star-icon"
                      ></i>
                    </span>
                    @if (
                      appointment &&
                      appointment.client_booked_details
                        .is_first_time_appointment
                    ) {
                      <span class="text-xs text-600">
                        {{ 'SCHEDULE.VIEWCLASS.FIRST_TIME' | translate }}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Client Name -->

        <!-- Payment Status -->
        @if (appointment) {
          <div
            class="md:w-6 flex py-2 md:py-0 px-2 align-items-center md:justify-content-end justify-content-between"
            aria-label="payment-status"
          >
            @if (!appointment.client_booked_details.is_payment_required) {
              <div class="flex align-items-center">
                <span
                  class="w-1rem h-1rem border-circle bg-green-600 mr-1"
                  aria-label="no-payment-required"
                ></span>
                <span class="text-xs text-600">{{
                  'SCHEDULE.VIEWCLASS.NO_DUES' | translate
                }}</span>
              </div>
            }
            @if (appointment.client_booked_details.is_first_time_appointment) {
              <div class="flex md:hidden align-items-center ml-2">
                <span
                  class="w-1rem h-1rem border-circle flex align-items-center justify-content-center surface-400 mr-2"
                >
                  <i
                    class="fa fa-star-fill text-primary text-xxs"
                    aria-label="first-time-icon"
                  ></i>
                </span>
                <span class="text-xs text-600">{{
                  'SCHEDULE.VIEWCLASS.FIRST_TIME' | translate
                }}</span>
              </div>
            }
            @if (appointmentData()!.clients[0].medical_alert) {
              <div
                (click)="GetClietMedicalDetails(appointmentData()!.clients[0])"
                class="ml-3 flex align-items-center cursor-pointer text-primary text-xs"
                data-testid="medical-alert-button"
              >
                <img
                  src="/assets/img/icons/icon-medical-alert.svg"
                  alt="Medical alert"
                />
                <span class="ml-2">{{
                  'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate
                }}</span>
              </div>
            }
          </div>
        }
        <!-- Payment Status -->
      </div>
      <!-- Header Bottom -->
    </div>
  </ng-template>

  <!-- Header -->

  <ng-template #content>
    <form
      class="p-sidebar-content__wrapper flex flex-column justify-content-between"
      [formGroup]="appointmentViewForm"
      aria-label="appointment-view-form"
    >
      <!-- Content Wrapper -->
      <div class="p-3">
        <!-- Form Group -->
        <div class="mb-3">
          <p-select
            [options]="getActions"
            formControlName="selectedAction"
            optionLabel="name"
            filterBy="name"
            styleClass="w-full text-sm shadow-2 border-2 border-primary"
            placeholder="{{
              'SCHEDULE.VIEWAPPOINTMENT.APPT_ACTION' | translate
            }}"
            (onChange)="selectAction($event)"
            dropdownIcon="fa fa-chevron-down text-primary"
            aria-label="action-dropdown"
          >
            <ng-template pTemplate="selectedItem">
              @if (selectedAction) {
                <div class="text-sm flex align-items-center">
                  <i class="{{ selectedAction.icon }} text-600 mr-2"></i>
                  <span>{{
                    'SCHEDULE.VIEWAPPOINTMENT.' + selectedAction.key | translate
                  }}</span>
                </div>
              }
            </ng-template>
            <ng-template let-actions pTemplate="item">
              <div class="text-sm flex align-items-center">
                <i class="{{ actions.icon }} text-600 mr-2"></i>
                <span>{{
                  'SCHEDULE.VIEWAPPOINTMENT.' + actions.key | translate
                }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-2">
          <label
            for="datetime-input"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="datetime-label"
            >{{ 'SCHEDULE.VIEWCLASS.LBL_DATETIME' | translate }}</label
          >
          <p-datepicker
            inputId="calendar-12h"
            [ngClass]="
              isApptAttendedOrCancelled ? 'opacity-40 pointer-events-none' : ''
            "
            formControlName="startDate"
            [showTime]="true"
            styleClass="text-sm w-full"
            inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
            [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
            [minDate]="minimumDate"
            [hourFormat]="'12'"
            (onClose)="OnScheduleDateSelect($event)"
            aria-label="datetime-calendar"
          />
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div
          class="w-full mb-3"
          [ngClass]="
            isApptAttendedOrCancelled ? 'opacity-40 pointer-events-none' : ''
          "
        >
          <!-- Input Field -->
          @if (appointment && appointment!.is_recurring && !RRuleObject.RRule) {
            <div
              class="p-input-icon-right w-full text-sm"
              (click)="showRRule = true"
              data-testid="repeat-input"
            >
              <div
                class="p-inputtext p-component p-element cursor-pointer bg-blue-50 w-full"
              >
                {{ 'SCHEDULE.VIEWCLASS.REPEAT' | translate }}
              </div>
            </div>
          }
          @if (appointment && appointment!.is_recurring && RRuleObject.RRule) {
            <div
              class="p-input-icon-right w-full text-sm cursor-pointer"
              data-testid="repeat-selected"
            >
              <div class="flex align-items-center">
                <i
                  class="fa fa-times text-base text-600 mr-2 cursor-pointer"
                  (click)="
                    showRRule = false;
                    RRuleObject.RRule = undefined;
                    RRuleObject.RRuleText = undefined
                  "
                  data-testid="clear-repeat"
                ></i>
                <div
                  class="p-inputtext p-component p-element w-full"
                  (click)="showRRule = true"
                >
                  {{ RRuleObject.RRuleText }}
                </div>
              </div>
            </div>
          }
          <!-- Input Field -->
        </div>
        <!-- Form Group -->

        @if (!isStaffAvailable) {
          <div class="-mt-2 px-1">
            <p-message
              severity="error"
              aria-label="staff-unavailable-message"
              icon="fa fa-times-circle"
              data-testid="staff-unavailable-message"
            >
              {{
                'STAFF_SCHEDULE.MSG.STAFF_UNAVAILABLE_MSG'
                  | translate: { name: SelectedTrainerFormControl.value.name }
              }}
            </p-message>
          </div>
        }
        <!-- Form Group -->
        <div class="mb-3">
          <label
            for="select-trainer-input"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="select-trainer-label"
            >{{ 'SCHEDULE.CREATECLASS.SELECTTRAINER' | translate }}</label
          >
          <staff-selector
            [formGroup]="appointmentViewForm"
            [controlName]="SelectedTrainerFormControl"
            [id]="selectedTrainerId"
            [styleClass]="'w-full text-sm'"
            [placeHolder]="'common.PLACEHOLDER.SEARCH_AND_SELECT' | translate"
            [filterstaff]="filterStaffIds"
            (selectedStaff)="getSelectedStaff($event)"
            aria-label="trainer-selector"
          />
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        @if (isVirtal) {
          <div class="mb-3">
            <label
              for="virtual-url-input"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="virtual-url-label"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_VIRTUALURL' | translate }}</label
            >
            <input
              type="url"
              class="text-sm w-full"
              pInputText
              formControlName="virtualUrl"
              #keyUpInputDelay
              placeholder="{{ 'SCHEDULE.VIEWCLASS.VIRTUALURL' | translate }}"
              (keyup)="onKeyUpDelay(keyUpInputDelay.value)"
              aria-label="virtual-url-input"
            />
            @if (
              VirtualUrlFormControl.touched && VirtualUrlFormControl.invalid
            ) {
              <app-error-msg
                [errors]="VirtualUrlFormControl.errors"
                [fieldLabel]="
                  'SCHEDULE.CREATEAPPOINTMENT.LBL_VIRTUALURL' | translate
                "
              />
            }
          </div>
          <!-- Form Group -->
        }
        <!-- Form Group -->
        @if (!isVirtal) {
          <div class="mb-3">
            <label
              for="select-room-input"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="select-room-label"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_ROOM' | translate }}</label
            >
            <select-room
              [formGroup]="appointmentViewForm"
              [controlName]="SelectedRoomFormControl"
              [tenantId]="tenantId()"
              [roomId]="selectedRoomId"
              [styleClass]="'w-full text-sm'"
              (selectedRoom)="getSelectedRoomEvent($event)"
              aria-label="room-selector"
            />
            @if (
              SelectedRoomFormControl.touched && SelectedRoomFormControl.invalid
            ) {
              <app-error-msg
                [errors]="SelectedRoomFormControl.errors"
                [fieldLabel]="'SCHEDULE.CREATEAPPOINTMENT.LBL_ROOM' | translate"
              />
            }
          </div>
          <!-- Form Group -->
        }
        <!-- Form Group -->
        @if (clientMemberships && clientMemberships.length > 1) {
          <div class="mb-2">
            <label
              for="subscriptions-input"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="subscriptions-label"
              >{{
                'SCHEDULE.CREATEAPPOINTMENT.SUBSCRIPTIONS' | translate
              }}</label
            >
            <p-select
              [options]="clientMemberships"
              formControlName="selectedMembership"
              optionLabel="subscription_primary_name"
              filterBy="subscription_primary_name"
              (onChange)="ChangeMembership($event)"
              styleClass="w-full text-sm"
              [placeholder]="
                'SCHEDULE.CREATEAPPOINTMENT.CHOOSE_SUBS_PLACEHOLDER' | translate
              "
              aria-label="subscription-dropdown"
            >
              <ng-template pTemplate="selectedItem">
                @if (selectedMembership) {
                  <div class="text-sm">
                    {{ selectedMembership.subscription_primary_name }}
                  </div>
                }
              </ng-template>
              <ng-template let-membership pTemplate="item">
                <div class="text-sm ml-2">
                  {{ membership.subscription_primary_name }}
                </div>
              </ng-template>
            </p-select>
          </div>
          <!-- Form Group -->
        }
        <!-- Form Group -->
        <div class="mb-3">
          <label
            for="comments-input"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="comments-label"
            >{{ 'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate }}</label
          >
          <textarea
            pInputTextarea
            class="w-full text-sm h-4rem"
            formControlName="comments"
            #CommentskeyUpInputDelay
            placeholder="{{ 'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate }}"
            (keyup)="onCommentsKeyUpDelay(CommentskeyUpInputDelay.value)"
            aria-label="comments-textarea"
          >
          </textarea>
        </div>
        <!-- Form Group -->

        <hr
          class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
        />

        @if (appointmentData()!) {
          <div class="grid text-sm" id="subpurpose-appointment-type">
            <div class="col-12 md:col-6">
              <label
                for="subpurpose-input"
                class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="subpurpose-label"
                >{{ 'SCHEDULE.VIEWAPPOINTMENT.SUBPURPOSE' | translate }}</label
              >
              <strong class="block">
                {{
                  appointmentData().subtype_name_primary_language ||
                    appointmentData().subtype_name_primary_language
                }}
              </strong>
            </div>

            <div class="col-12 md:col-6">
              <label
                for="appointment-type-input"
                class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="appointment-type-label"
                >{{ 'SCHEDULE.CREATEAPPOINTMENT.APPT_TYPE' | translate }}</label
              >
              <strong class="flex align-items-center">
                <i
                  class="fa fa-users mr-3"
                  aria-label="appointment-type-icon"
                ></i>
                {{ appointmentData()!.behaviour }}
              </strong>
            </div>
          </div>
        }
      </div>

      <!-- Content Wrapper -->

      <!-- Footer -->
      <div
        class="sticky bottom-0 left-0 z-3 flex align-items-center justify-content-between border-top-1 border-300 p-2 md:p-3 bg-primary"
      >
        <button
          pButton
          pRipple
          type="button"
          class="p-button-raised p-button-text w-6 mr-1 md:mr-2 p-2 md:p-3 text-xs md:text-sm font-bold"
          (click)="MarkClientAsAttended(appointmentAttended)"
          [ngClass]="
            appointmentAttended
              ? 'bg-green-500 text-white pointer-events-none'
              : 'p-button-success text-green-500 surface-0'
          "
          [disabled]="isApptAttendedOrCancelled"
          aria-label="mark-attended-button"
        >
          <i class="fa fa-check-square mr-2"></i>
          <span>
            @if (appointmentAttended) {
              <div>
                {{ 'SCHEDULE.VIEWAPPOINTMENT.MARK_ATTENDED' | translate }}
              </div>
            } @else {
              <div>{{ 'SCHEDULE.VIEWAPPOINTMENT.ATTENDED' | translate }}</div>
            }
          </span>
        </button>
        <button
          (click)="!appointmentNoShow ? noShowOverlay.toggle($event) : ''"
          pButton
          pRipple
          type="button"
          class="p-button-raised text-900 w-6 ml-1 md:ml-2 p-2 md:p-3 border-none text-xs md:text-sm font-bold"
          [ngClass]="
            appointmentNoShow ? 'bg-red text-white' : 'p-button-text surface-0'
          "
          [disabled]="isApptAttendedOrCancelled"
          aria-label="mark-no-show-button"
        >
          <i
            class="fa fa-times text-xl-circle mr-2"
            [ngClass]="appointmentNoShow ? 'text-white' : 'p-error'"
          ></i>
          <span>
            @if (appointmentNoShow) {
              <div>
                {{ 'SCHEDULE.VIEWAPPOINTMENT.MARK_NOSHOW' | translate }}
              </div>
            } @else {
              <div>{{ 'SCHEDULE.VIEWAPPOINTMENT.NOSHOW' | translate }}</div>
            }
          </span>
        </button>

        <p-popover #noShowOverlay>
          <ng-template #content>
            <div class="flex align-items-center">
              <i
                class="fa fa-exclamation-triangle p-error mr-2"
                aria-label="warning-icon"
              ></i>
              <span
                class="text-sm"
                [innerHtml]="
                  'SCHEDULE.VIEWAPPOINTMENT.NOSHOW_WARNING' | translate
                "
              ></span>
            </div>
            <div class="flex justify-content-end mt-3">
              <button
                (click)="noShowOverlay.hide()"
                pButton
                pRipple
                type="button"
                [label]="'common.BUTTONS.BUTTON-TEXT-NO' | translate"
                class="p-button-text p-button-sm text-sm mr-2"
                aria-label="no-button"
              ></button>
              <button
                (click)="
                  MarkClientAsNoShow(appointmentNoShow); noShowOverlay.hide()
                "
                pButton
                pRipple
                type="button"
                [label]="'common.BUTTONS.BUTTON-TEXT-YES' | translate"
                class="p-button-sm text-sm"
                aria-label="yes-button"
              ></button>
            </div>
          </ng-template>
        </p-popover>
      </div>
      <!-- Footer -->
    </form>
  </ng-template>
</p-drawer>
<!-- Sidebar -->

<!-- Cancel Appointment Modal -->
<p-dialog
  [visible]="cancelAppointment"
  (onHide)="cancelAppointment = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '470px' }"
  styleClass="no-header-modal"
  aria-label="cancel-appointment-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="deleteAppointmentForm">
      <!-- Content -->
      <div class="relative text-center px-4 py-5">
        <div
          class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="cancelAppointment = false"
          data-testid="close-delete-dialog"
        ></div>

        <i
          class="fa fa-exclamation-triangle p-error text-7xl mt-5"
          aria-label="warning-icon"
        ></i>

        <h4
          class="text-base md:text-lg mb-2 mt-5 mb-0 font-bold"
          aria-label="delete-title"
        >
          {{ 'SCHEDULE.VIEWAPPOINTMENT.CANCEL_CONFIM' | translate }} <br />
          {{
            appointmentData()!.type_name_primary_language ||
              appointmentData()!.tenant_name_secondary_language
          }}
          for
          {{
            appointmentData().start_datetime | datetimeformat: 'mediumDate'
          }}
          ?
        </h4>
      </div>

      <div class="surface-100 p-4">
        <label
          for="cancellation-reason-input"
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="cancellation-reason-label"
          >{{ 'SCHEDULE.VIEWAPPOINTMENT.CANCEL_REASON' | translate }}</label
        >
        <textarea
          pInputTextarea
          class="w-full text-sm h-7rem mb-3"
          formControlName="cancellation_reason"
          placeholder="{{
            'SCHEDULE.VIEWAPPOINTMENT.CANCEL_REASON' | translate
          }}"
          aria-label="cancellation-reason-input"
        ></textarea>
      </div>

      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="cancelAppointment = false"
          aria-label="cancel-appointment-button"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'SCHEDULE.VIEWAPPOINTMENT.CONTINUE' | translate"
          class="p-button-danger text-sm"
          [loading]="btnLoading"
          (click)="CancelAppointment(deleteAppointmentForm)"
          aria-label="continue-cancel-appointment-button"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Cancel Appointment Modal -->

<!-- Delete Appointment Modal -->
<p-dialog
  [visible]="deleteAppointmentPopup"
  (onHide)="deleteAppointmentPopup = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '470px' }"
  styleClass="no-header-modal"
  aria-label="delete-appointment-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="relative text-center px-4 py-5">
      <div
        class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="deleteAppointmentPopup = false"
        data-testid="close-delete-appointment-dialog"
      ></div>
      <i
        class="fa fa-exclamation-triangle p-error text-7xl mt-5"
        aria-label="warning-icon"
      ></i>
      <h4
        class="text-base md:text-lg mb-2 my-5 font-bold"
        aria-label="delete-confirmation-title"
      >
        {{ 'SCHEDULE.VIEWAPPOINTMENT.DELETE_CONFIM' | translate }} <br />
        {{
          appointmentData()!.type_name_primary_language ||
            appointmentData()!.tenant_name_secondary_language
        }}
        {{ 'SCHEDULE.VIEWCLASS.FOR' | translate }}
        {{ appointmentData().start_datetime | datetimeformat: 'mediumDate' }} ?
      </h4>
    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div
      class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
    >
      <button
        pButton
        pRipple
        type="button"
        [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        class="p-button-secondary p-button-text text-sm"
        (click)="deleteAppointmentPopup = false"
        aria-label="cancel-delete-appointment-button"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        [label]="'SCHEDULE.VIEWAPPOINTMENT.CONTINUE' | translate"
        [loading]="btnLoading"
        class="p-button-danger text-sm"
        (click)="DeleteAppointment()"
        aria-label="confirm-delete-appointment-button"
      ></button>
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Delete Appointment Modal -->

<!-- Duplicate Appointment Modal  -->
@if (duplicateAppointment) {
  <duplicate-appointment
    [visible]="duplicateAppointment"
    [appointmentData]="appointment"
    [tenantId]="tenantId()"
    [form]="duplicateAppointmentForm"
    (CloseDuplicateAppointment)="CloseDuplicatePopup($event)"
    aria-label="duplicate-appointment-dialog"
  />
}
<!-- Duplicate Appointment Modal  -->

<!-- Medical ALert Modal -->
<p-dialog
  [visible]="showMedicalAlert"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '450px' }"
  styleClass="no-header-modal"
  (onHide)="showMedicalAlert = false; clientMedicalDetails = null"
  aria-label="medical-alert-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <div
        [innerHtml]="
          'SCHEDULE.VIEWCLASS.MEDICAL_ALERT_FOR'
            | translate: { name: clientMedicalDetails?.full_name ?? '' }
        "
        aria-label="medical-alert-title"
      ></div>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="showMedicalAlert = false; clientMedicalDetails = null"
        data-testid="close-medical-alert"
      ></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div
      class="p-4 surface-50"
      [innerHtml]="clientMedicalDetails?.medical_alert ?? ''"
      aria-label="medical-alert-content"
    ></div>
    <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Medical Alert Modal -->

<!-- Show Recurring Event Modal -->
<p-dialog
  [visible]="showRecurringEventUpdatePopup"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '350px' }"
  styleClass=""
  [blockScroll]="true"
  [closable]="false"
  aria-label="recurring-event-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden"
    >{{ 'SCHEDULE.VIEWAPPOINTMENT.EDIT_RECURRING_EVENT' | translate }}
  </ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="updateEventForm">
      <ul class="list-none p-0 m-0 text-sm">
        <li class="my-3 flex align-items-start">
          <p-radioButton
            name="updateEvent"
            value="ThisEvent"
            inputId="option1"
            formControlName="updateEvent"
            aria-label="this-event-option"
          />
          <label class="ml-2" for="option1">{{
            'SCHEDULE.VIEWAPPOINTMENT.THIS_EVENT' | translate
          }}</label>
        </li>
        <li class="my-3 flex align-items-start">
          <p-radioButton
            name="updateEvent"
            value="ThisAndFollowingEvents"
            inputId="option2"
            formControlName="updateEvent"
            aria-label="this-and-following-option"
          />
          <label class="ml-2" for="option2">{{
            'SCHEDULE.VIEWAPPOINTMENT.THIS_AND_FOLLOWING' | translate
          }}</label>
        </li>
      </ul>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      type="button"
      [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
      class="p-button-secondary p-button-text text-sm"
      (click)="UpdateEvent(false)"
      aria-label="cancel-recurring-event-button"
    ></button>
    <button
      pButton
      pRipple
      type="button"
      [label]="'common.BUTTONS.BUTTON-TEXT-OK' | translate"
      class="text-sm"
      [disabled]="!formIsvalid"
      [loading]="btnLoading"
      (click)="UpdateEvent(true, $event)"
      aria-label="update-recurring-event-button"
    ></button>
  </ng-template>

  <p-confirmpopup key="bookconfirm" class="z-2104" />
</p-dialog>
<!-- Show Recurring Event Modal -->

<!-- Comp Session -->
<p-dialog
  [visible]="showCompSessionPopup"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal overflow-visible"
  aria-label="comp-session-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="complimentoryForm">
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-base md:text-lg" aria-label="comp-session-title">
          {{ 'CLIENT_BOOKING.HEADER' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeCompSessionPopup()"
          data-testid="close-comp-session"
        ></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 text-sm p-4">
        <label
          for="comp-reason-input"
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="comp-reason-label"
          >{{ 'CLIENT_BOOKING.COMP_REASON' | translate }}</label
        >
        <textarea
          pInputTextarea
          class="w-full h-5rem"
          formControlName="comments"
          [placeholder]="'CLIENT_BOOKING.COMP_REASON_PLACEHOLDER' | translate"
          aria-label="comp-reason-input"
        ></textarea>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-text text-sm"
          (click)="closeCompSessionPopup()"
          aria-label="cancel-comp-session-button"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'CLIENT_BOOKING.COMP_SESSION' | translate"
          class="text-sm"
          (click)="ComplimentoryAppointment(complimentoryForm)"
          [loading]="isComplimentoryLoading"
          aria-label="complimentory-session-button"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Comp Session -->

<app-rrule
  [visible]="showRRule"
  (onHide)="HideRRule({})"
  [showNeverStop]="true"
  [minimumDate]="minimumDate"
  [rRuleObj]="RRuleObject"
  (hideRrule)="HideRRule($event)"
  (emitRRule)="FetchRRuleData($event)"
  aria-label="recurrence-rule-dialog"
/>

@if (showErrorPopup$ | async; as showPopup) {
  <app-errors
    [error]="error"
    [visible]="showPopup"
    [errorData]="errorMessages"
    (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="error-dialog"
  />
}
